import _ from "lodash";
import { Article } from "../../../../api/schema";
import { UserLanguage } from "../../../../lang/lang";
import { NewParameter } from "./NewParameter";
import { ArticleParameterRow } from "./ParameterRow";

interface ArticleParameterSettingsProps {
  article: Article;
  on_changed: () => void;
}

export const ArticleParameterSettings = (
  props: ArticleParameterSettingsProps
) => (
  <div>
    <div className="aw_apa_header">
      <h3>{UserLanguage().data.article.fields}</h3>
      <NewParameter article={props.article} on_created={props.on_changed} />
    </div>
    <div>
      {_(props.article.fields)
        .sortBy([
          (f) =>
            _.get(
              UserLanguage().data.fields,
              f.key_field.name,
              f.key_field.name
            ),
        ])
        .map((field) => (
          <ArticleParameterRow
            key={field.id}
            field={field}
            on_changed={props.on_changed}
          />
        ))
        .value()}
    </div>
  </div>
);
